export const APPLICATION_STATUS = {
  new: { label: 'New', color: 'default' },
  shortlisted: { label: 'Shortlisted', color: 'info' },
  accepted: { label: 'Accepted', color: 'success' },
  rejected: { label: 'Rejected', color: 'error' },
};

export const APPLICATION_STATUS_ACTIONS = [
  { status: 'shortlisted', label: 'Shortlist', notifies: true },
  { status: 'accepted', label: 'Accept', notifies: true },
  { status: 'rejected', label: 'Reject', notifies: true },
  { status: 'new', label: 'Move back to New', notifies: false },
];
